/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as ioTs from "io-ts";

export const Country = ioTs.type({
  code: ioTs.string,
  name: ioTs.string,
});
export type Country = ioTs.TypeOf<typeof Country>;

export const CountryList = ioTs.array(Country);
export type CountryList = ioTs.TypeOf<typeof CountryList>;

export const LanguageList = ioTs.record(ioTs.string, ioTs.string);
export type LanguageList = ioTs.TypeOf<typeof LanguageList>;

export class BasicDecodeError extends Error {
  constructor(m?: string) {
    super(m);
    Object.setPrototypeOf(this, BasicDecodeError.prototype);
  }
}
